import { useCallback, useEffect, useRef, useState } from 'react'

export function useZoomedPageResizableContainer() {
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false)
  const [containerHeight, setContainerHeight] = useState<number>(0)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const containerRef = useRef<HTMLDivElement>(null)

  const initPagesOnDocumentLoad = useCallback(() => {
    setIsDocumentLoaded(true)
  }, [])

  const updateSize = useCallback(() => {
    if (isDocumentLoaded && containerRef.current) {
      setContainerHeight(containerRef.current.offsetHeight)
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [isDocumentLoaded])

  useEffect(() => {
    updateSize()

    const resizeObserver = new ResizeObserver(() => updateSize())
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [updateSize, isDocumentLoaded])

  return {
    containerRef,
    containerHeight,
    containerWidth,
    initPagesOnDocumentLoad,
    isDocumentLoaded,
  }
}
